import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import {
  cardSizeMobileStyles,
  cardSizeStyles,
} from '@/modules/content/components/ContentCard/styles';

export const LIST_CARD_SIZE = {
  default: {
    height: 15.6,
    width: 0,
    maxWidth: 80.8,
  },
};

export const LIST_CARD_IMAGE_SIZE = {
  default: {
    height: 10.8,
    width: 14.4,
  },
  mobile: {
    height: 8,
    width: 8,
  },
};

export const listCardSizeStyles = cn(cardSizeStyles(LIST_CARD_SIZE.default));

export const listCardImageStyles = cn(
  cardSizeStyles(LIST_CARD_IMAGE_SIZE.default),
  cardSizeMobileStyles(LIST_CARD_IMAGE_SIZE.mobile),
);

export const listCardImageMobileStyles = cardSizeMobileStyles(LIST_CARD_IMAGE_SIZE.mobile);

export const imageOverlayStyles = css`
  background-color: rgba(0, 0, 0, 0.1);
`;

export const LIST_CARD_IMAGE_CONTAINER_STYLES =
  'rounded-16 group-hover:shadow-03 transform group-hover:-translate-y-8 transition-all duration-300';
